import { render } from "./imageUploader.vue?vue&type=template&id=8f1b9daa"
import script from "./imageUploader.vue?vue&type=script&lang=js"
export * from "./imageUploader.vue?vue&type=script&lang=js"

import "./imageUploader.vue?vue&type=style&index=0&id=8f1b9daa&lang=scss"

import exportComponent from "D:\\_laravelProjects\\2sport\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__